import axios from "axios";
import { ClientDto } from "../../dto/client.dto";

export function fetchClient(
  clientCode: string,
  slug: string
): Promise<{ data: ClientDto }> {
  return axios.post("client", {
    code: clientCode,
    slug,
  });
}
